import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import RingOneImg from "../../../../Assets/images/home/engagement-rings.webp"
import RingTwoImg from "../../../../Assets/images/home/wedding-bands.webp"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../../../../Components/LocalizedLink'
export default function TwoRingCards() {
    const { t } = useTranslation()
    return (
        <section className="section-space">
            <Container fluid className="home-showcase-container two_ring_cards_section">
                <Row>
                    <Col xs="12" className="card_container">
                        <div>
                            <div className="img-box">
                                <img src={RingOneImg} loading="lazy" alt="Engaement Ring" />
                            </div>
                            <LocalizedLink to="/engagement-rings">  <h2>{t('twoRingCard.engagementRings')}</h2></LocalizedLink>
                            <LocalizedLink to="/engagement-rings">      <button className="golden-btn mx-auto">{t('twoRingCard.shopnow')}</button> </LocalizedLink>

                        </div>
                        <div>
                            <div className="img-box">
                                <img src={RingTwoImg} loading="lazy" alt="Wedding Ring" />
                            </div>
                            <LocalizedLink to="/wedding-rings"> <h2> {t('twoRingCard.weddingband')}</h2></LocalizedLink>
                            <LocalizedLink to="/wedding-rings"> <button className="golden-btn mx-auto">{t('twoRingCard.shopnow')}</button> </LocalizedLink>

                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
